import { atom } from "recoil";

export const engageAvailableDeps = atom({
  key: "engageAvailableDeps",
  default: [{ name: "All", id: "all" }],
});

export const engageDepartmentState = atom({
  key: "engageDepartment",
  default: { name: "All", id: "all" },
});

export const engageTimeSpanState = atom({
  key: "engageTimeSpan",
  default: { name: "2026", id: "2026" },
});

export const engageMeetingsState = atom({
  key: "engageMeetings",
  default: [],
});

export const engageEmbedState = atom({
  key: "engageEmbed",
  default: false,
});

export const engageSearchResults = atom({
  key: "engageSearch",
  default: [],
});

export const engageCalendarMeetings = atom({
  key: "engageCalendar",
  default: [],
});

export const engageDayEvents = atom({
  key: "engageDayEvents",
  default: [],
});

export const engageDaySelected = atom({
  key: "engageDaySelected",
  default: null,
});

export const engageDayFormatted = atom({
  key: "engageDayFormmated",
  default: null,
});

export const engageUpcomingMeetings = atom({
  key: "engageUpcoming",
  default: [],
});
